import { render, staticRenderFns } from "./title-text.vue?vue&type=template&id=27cbe61a&scoped=true"
import script from "./title-text.vue?vue&type=script&lang=js"
export * from "./title-text.vue?vue&type=script&lang=js"
import style0 from "./title-text.vue?vue&type=style&index=0&id=27cbe61a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27cbe61a",
  null
  
)

export default component.exports